import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingNabidkaKalkulacePage = lazy(() =>
  import('@/modules/leasing/LeasingKalkulace').then((m) => ({
    default: m.LeasingNabidkaKalkulacePage,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/nabidky/$id/kalkulace',
  component: () => (
    <Suspense fallback={null}>
      <LeasingNabidkaKalkulacePage />
    </Suspense>
  ),
});
